import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function DeleteUserForm({ onDelete }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const { userId } = useParams();
  // const API_BASE_URL = 'http://localhost:5000/api/admin/user';
  const API_BASE_URL = API.API_ADMIN + '/user';
  const JWT_TOKEN = localStorage.getItem('authToken'); // Ganti dengan token yang valid

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/${userId}`, {
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setUserDetails(data);
    } catch (error) {
      console.error('Error fetching user details:', error);
      setError('Failed to fetch user details. Please try again.');
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserDetails();
    }
  }, [userId]);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await fetch(`${API_BASE_URL}/${userId}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Handle successful deletion
      console.log('User deleted successfully');
      if (onDelete) onDelete(); // Optional: Callback on success
      setShowConfirmation(false);
      window.location.href = '/admin/user'; // Redirect to user list or any other page
    } catch (error) {
      console.error('Error deleting user:', error);
      setError('Failed to delete user. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };
  const handleCancel = () => {
    setShowConfirmation(false);
    window.location.href = "/admin/user";
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Delete User</h3>
      {error && <p className="text-red-500 text-xs">{error}</p>}
      {userDetails && !showConfirmation && (
        <div className="mb-4">
          <p><strong>Username:</strong> {userDetails.username}</p>
          <p><strong>Email:</strong> {userDetails.email}</p>
          <p><strong>Role:</strong> {userDetails.role}</p>
          <p><strong>Phone:</strong> {userDetails.telepon}</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={() => setShowConfirmation(true)}
          >
            Delete User
          </button>
        </div>
      )}
      {showConfirmation && (
        <div>
          <p>Are you sure you want to delete this user?</p>
          <button
            type="button"
            className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Confirm Delete'}
          </button>
          <button
            type="button"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

DeleteUserForm.propTypes = {
  userId: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};
